export const DEPARTMENTS = [
  'Tech', 'Finance', 'Sales', 'Marketing', 'Tech Support',
  'Customer Service', 'Legal', 'Product', 'AI', 'Delivery', 'HR',
] as const;

export const FILTER_STATUSES = [
  'draft', 'submitted', 'under_triage', 'needs_clarification', 'meeting_scheduled',
  'in_review', 'awaiting_decision', 'awaiting_deployment', 'approved', 'approved_with_conditions',
  'parked', 'rejected', 'shipped',
] as const;

export const LOCKED_PROPOSAL_STATUSES = [
  'rejected', 'parked',
] as const;
